import { useFeatureFlag } from './useFeatureFlag';

export const PXTRA_CARD_FEATURE_FLAG = 'PXTRA_CARD';

/**
 * Whether this company has the pxtra Card at all. Everything card-related —
 * the menu entry, the setup notice, the todo dot — hangs off this, so a
 * company that has not booked the card never learns it exists.
 *
 * `isLoading` is separate on purpose: treating "not loaded yet" as disabled
 * would hide the entry on every reload and pop it back in.
 */
export const usePxtraCardEnabled = () => {
  const { isEnabled, isLoading } = useFeatureFlag(PXTRA_CARD_FEATURE_FLAG);

  return { isCardEnabled: isEnabled, isLoading };
};
